import React from 'react'
import PropTypes from 'prop-types'
import Cat from '../../../assets/svg/cat.svg'
import ztlogo from '../../../assets/images/zero_touch_logo.svg'
import { FormattedMessage } from 'react-intl'
import Parser from 'html-react-parser'
import config from '../../../config'
import {
  NotficationContainer,
  BarContent,
  ReadMore,
  FixedBar,
  Button,
  TextWrapper,
  ContentWrapper,
  CatImageWrapper
} from './TopBarNotificationBoxStyledComponents'

export const TopBarNotificationBox = React.memo(
  ({
    title,
    icon: Icon,
    content,
    toggleGeolocationModal,
    actionButton,
    fixedBar,
    fixedBarMessage,
    fixedBarActionMessage,
    storeSource
  }) => {
    const isZeroTouch = storeSource === 'ZEROTOUCH'
    return (
      <React.Fragment>
        <NotficationContainer id='topBar' zt={isZeroTouch}>
          <ContentWrapper>
            <CatImageWrapper>
              <img src={isZeroTouch ? ztlogo : Cat} alt='Logo' />
            </CatImageWrapper>
            <TextWrapper>
              <h4>{title}</h4>
              <span>{content}</span>
            </TextWrapper>
            {actionButton && (
              <Button color='primary' onClick={() => toggleGeolocationModal()}>
                <FormattedMessage id='topBarNotification.howToEnable' />
              </Button>
            )}
          </ContentWrapper>
        </NotficationContainer>
        {fixedBar && (
          <FixedBar>
            <BarContent>
              <Icon />
              <span>{Parser(fixedBarMessage)}</span>
            </BarContent>
            <ReadMore
              to={config.privacyPolicyUrl}
              onClick={() =>
                document.getElementById('topBar').scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                })
              }
            >
              {fixedBarActionMessage}
            </ReadMore>
          </FixedBar>
        )}
      </React.Fragment>
    )
  }
)

TopBarNotificationBox.displayName = 'TopBarNotificationBox'

TopBarNotificationBox.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.func,
  content: PropTypes.string,
  toggleGeolocationModal: PropTypes.func,
  actionButton: PropTypes.bool,
  fixedBar: PropTypes.bool,
  fixedBarMessage: PropTypes.string,
  fixedBarActionMessage: PropTypes.string,
  storeSource: PropTypes.string
}

export default TopBarNotificationBox
